// Module
var code = `<template>
  <require from="./nav-key-figures-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .nav-key-figures-widget-\${id} td {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
    }

    .nav-key-figures-widget-\${id} th {
      font-family: \${captionFont ? captionFont : 'var(--dyn-default-caption-font-family)'};
      font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-caption-font-size)'};
      color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
    }
  </style>
  <!-- beautify ignore:end -->

  <global-progress if.bind="loading"></global-progress>
  <div if.bind="!loading && !error" class="nav-key-figures-widget nav-key-figures-widget-\${id}">
    <table>
      <thead if.bind="showLabels">
        <tr>
          <th if.bind="showLabels"></th>
          <th class="nav-key-figures-widget__numeric" if.bind="showLastMonth">Last month</th>
          <th class="nav-key-figures-widget__numeric" if.bind="showYTD">YTD</th>
          <th class="nav-key-figures-widget__numeric" if.bind="showYTDLastMonth">YDT LM</th>
        </tr>
      </thead>
      <tbody>
        <tr if.bind="showNav">
          <td if.bind="showLabels">NAV</td>
          <td class="nav-key-figures-widget__numeric" if.bind="showLastMonth">
            \${navLM | numericFormatter:'twoDec'}%
          </td>
          <td class="nav-key-figures-widget__numeric" if.bind="showYTD">
            \${navYTD | numericFormatter:'twoDec'}%
          </td>
          <td class="nav-key-figures-widget__numeric" if.bind="showYTDLastMonth">
            \${navYTDLM | numericFormatter:'twoDec'}%
          </td>
        </tr>
        <tr if.bind="showOsebx">
          <td if.bind="showLabels">OSEBX</td>
          <td class="nav-key-figures-widget__numeric" if.bind="showLastMonth">
            \${osebxLM | numericFormatter:'twoDec'}%
          </td>
          <td class="nav-key-figures-widget__numeric" if.bind="showYTD">
            \${osebxYTD | numericFormatter:'twoDec'}%
          </td>
          <td class="nav-key-figures-widget__numeric" if.bind="showYTDLastMonth">
            \${osebxYTDLM | numericFormatter:'twoDec'}%
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="nav-key-figures-widget__error">
    \${error.message}</message>
  <div if.bind="noGL" class="nav-key-figures-widget__no-gl-warning warning">
    Warning: No GL data available for this period
  </div>
</template>
`;
// Exports
export default code;